export default __webpack_public_path__ + "static/media/feminipsum.bba7ff67.png";